import { TestTemplateMetadata } from 'shared/types';

export const elementaryTableTests: TestTemplateMetadata[] = [
  {
    test_name: 'elementary.freshness_anomalies',
    description:
      'A time-bucket-based freshness anomaly test that detects anomalies when recent update intervals deviate significantly from historical ones. Requires a timestamp column representing insertion or update time to evaluate updates freshness across time buckets (daily by default).',
    popularity: 1,
    quality_dimension: 'freshness',
    supports_conditional_severity: false,
  },
  {
    test_name: 'elementary.event_freshness_anomalies',
    description:
      'Monitors the freshness of event data over time, that is the time between when the event actually occurs (the event timestamp), and when it is loaded to the database (the update timestamp)',
    popularity: 1,
    quality_dimension: 'freshness',
    supports_conditional_severity: false,
  },
  {
    test_name: 'elementary.volume_anomalies',
    description:
      'A time-bucket-based volume anomaly test that detects significant volume outliers by monitoring row count trends over time. If no timestamp column is provided, it defaults to tracking total row count per time bucket (daily by default).',
    popularity: 1,
    supports_conditional_severity: false,
  },
  {
    test_name: 'elementary.dimension_anomalies',
    description:
      'Monitors the distribution of values in a configured dimension over time, and alerts on unexpected changes in the distribution',
    popularity: 1,
    supports_conditional_severity: false,
  },
  {
    test_name: 'elementary.schema_changes',
    description:
      'Monitors schema changes to detect deleted table, deleted or added columns, or change of data type of a column',
    popularity: 1,
    supports_conditional_severity: false,
  },
];

export const elementaryColumnTests: TestTemplateMetadata[] = [
  {
    test_name: 'dbt_core.unique',
    description:
      'Validates that there are no duplicate values present in a field (i.e. The customer_id column in the customers table should contain only unique values)',
    popularity: 1,
    quality_dimension: 'uniqueness',
    supports_conditional_severity: true,
  },
  {
    test_name: 'dbt_core.not_null',
    description:
      'Validates that there are no null values present in a column (i.e. The order_id column in the orders table should not contain null values)',
    popularity: 1,
    quality_dimension: 'completeness',
    supports_conditional_severity: true,
  },
  {
    test_name: 'dbt_core.accepted_values',
    description:
      'Validates that all the values in a column are present in a list of pre-defined values (i.e. the status column in the orders table should be one of the following: placed, shipped, completed, returned)',
    popularity: 1,
    quality_dimension: 'validity',
    supports_conditional_severity: true,
  },
  {
    test_name: 'dbt_core.relationship',
    description:
      'Validates that all of the records in a child table have a corresponding record in a parent table (i.e. Each existing customer_id in the orders table to have a correlating id in the customers table)',
    popularity: 1,
    quality_dimension: 'consistency',
    supports_conditional_severity: true,
  },
];
